export interface AiTravelPlannerRequest {
  chatInput: string;
  availablePlaces: string[];
}

export interface AiTravelPlannerResponse {
  output?: string;
  Places?: string[];
  extractedIdeas?: string[];
  original_input?: string;
  PlacesResponse?: {
    Name: string;
    Reasons: string[];
    Suggestions: string;
    Tags: string[];
  }[];
}

// Simple search history utility
const SEARCH_HISTORY_KEY = 'playground_search_history';

export const addSearchToHistory = (searchValue: string): void => {
  if (typeof window === 'undefined' || !searchValue.trim()) return;

  try {
    const current = JSON.parse(sessionStorage.getItem(SEARCH_HISTORY_KEY) || '[]');
    const updated = [searchValue.trim(), ...current.filter((item: string) => item !== searchValue.trim())].slice(0, 50);
    sessionStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(updated));
  } catch {
    // Silently fail if session storage is not available
  }
};

export const getSearchHistory = (): string[] => {
  if (typeof window === 'undefined') return [];
  try {
    return JSON.parse(sessionStorage.getItem(SEARCH_HISTORY_KEY) || '[]');
  } catch {
    return [];
  }
};
